import { Field } from '@lightspeed/unified-components-helios-theme/react'
import { useT } from '@transifex/react'
import React from 'react'
import { LINE_ITEM_NOTE_LENGTH } from '../../../../models/line-item'
import { NoteField } from '../../../shared/NoteField'
import { LineItemNoteProps, useLineItemNoteModel } from './useLineItemNoteModel'

export const LineItemNote: React.FC<LineItemNoteProps> = props => {
  const t = useT()
  const model = useLineItemNoteModel(props)

  return (
    <>
      {!model.isReadOnly ? (
        <NoteField
          value={props.lineItem.note}
          charLimit={LINE_ITEM_NOTE_LENGTH}
          label={t('Note')}
          placeholder={t('Enter a note', { _context: 'sale note placeholder' })}
          name="lineItemNote"
          onChange={model.onNoteChange}
          onBlur={model.saveSale}
          onErrorsChange={model.onNoteErrorsChange}
        />
      ) : (
        props.lineItem.note && (
          <Field
            labelSlot={t('Note')}
            customClasses={{ label: 'typography-body-sm-emphasized' }}
          >
            <div className="typography-body-sm">{props.lineItem.note}</div>
          </Field>
        )
      )}
    </>
  )
}
